$(document).on('turbolinks:load', function() {
  // because of our frontend caching strategy, our forms can sometimes be cached (especially the
  // execution log forms) which will cause a submission error if the CSRF token rotates after
  // the form is cached. This updates the token with the value in the meta tag in the header to
  // ensure it's fresh
  $('input[name=authenticity_token]').val($('meta[name=csrf-token]').attr('content'))
})
